import { WellGeothermalTemperatureFields } from '../../../../types/form-types'
import { SetValue, ValidationErrors } from '../../../hooks/use-edit-form'
import { DISPLAY_DATE_FORMAT, INTERNAL_DATE_FORMAT } from '../../../services/constants'
import { format } from 'date-fns'
import { parseDate } from '../../aoraki/generic-search-common/src'
import { preventChangeOnScroll } from '../../../services/form-utils'
import { DateField, FormField, InputWidth, TextInput } from '@msaf/core-react'

interface WellGeothermalTemperatureInterface {
  fields: Partial<WellGeothermalTemperatureFields>
  isLoading: boolean
  setValue: SetValue<WellGeothermalTemperatureFields>
  validationErrors: ValidationErrors<WellGeothermalTemperatureFields>
}

export default function WellGeothermalTemperatureEdit({
  fields,
  isLoading,
  validationErrors,
  setValue,
}: WellGeothermalTemperatureInterface) {
  return (
    <>
      <FormField isSkeleton={isLoading} label='Date' htmlFor='date' validationMessages={validationErrors?.date}>
        <DateField
          isSkeleton={isLoading}
          isDisabled={isLoading}
          fieldSize={InputWidth.large}
          dateFormat={DISPLAY_DATE_FORMAT}
          selectedDate={parseDate(fields.date)}
          setSelectedDate={(date: Date) => setValue('date', date ? format(date, INTERNAL_DATE_FORMAT) : '')}
        />
      </FormField>
      <FormField isSkeleton={isLoading} label='Depth (m)' htmlFor='depth' validationMessages={validationErrors?.depth}>
        <TextInput
          isSkeleton={isLoading}
          fieldSize={InputWidth.large}
          type='number'
          onWheel={preventChangeOnScroll}
          id='depth'
          value={`${fields.depth ?? ''}`}
          setValue={(value) => setValue('depth', value)}
          isInvalid={!!validationErrors?.depth}
        />
      </FormField>
      <FormField
        isSkeleton={isLoading}
        label='Temperature (oC)'
        htmlFor='temperature'
        validationMessages={validationErrors?.temperature}
      >
        <TextInput
          isSkeleton={isLoading}
          fieldSize={InputWidth.large}
          type='number'
          onWheel={preventChangeOnScroll}
          id='temperature'
          value={`${fields.temperature ?? ''}`}
          setValue={(value) => setValue('temperature', value)}
          isInvalid={!!validationErrors?.temperature}
        />
      </FormField>
    </>
  )
}
